var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.displayConfirmBankTransferSection(_vm.order)
        ? _c("div", { staticClass: "card panel-white" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("label", { staticClass: "mb-0" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.confirm_order_payment.incomplete_payment")
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.order.payment_data.method === "pending"
                  ? [
                      _c("div", { staticClass: "mt-3" }, [
                        _vm._m(0),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "message.confirm_order_payment.provider_offer_booking"
                              )
                            ) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-3" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info btn-block",
                            on: {
                              click: function($event) {
                                return _vm.clearTempData()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.button.go_to_payment")) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    ]
                  : _vm.order.payment_data.method === "bank_transfer" ||
                    _vm.order.payment_data.method === "promptpay"
                  ? [
                      _vm.globalState
                        ? [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.bankTransferDurationText(
                                    _vm.order,
                                    _vm.globalState
                                  )
                                )
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.order.is_reviewed
                        ? _c(
                            "div",
                            { staticClass: "mt-3" },
                            [
                              _vm.order.payment_data.method === "promptpay"
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-info btn-block",
                                      attrs: {
                                        to:
                                          "/orders/" +
                                          _vm.order.id +
                                          "/confirm-promptpay"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.openConfirmBankTransferModal()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.button.go_to_payment"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.payment_data.method === "bank_transfer"
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-info btn-block",
                                      on: {
                                        click: function($event) {
                                          return _vm.openConfirmBankTransferModal()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.button.confirm_bank_transfer"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  : _vm.order.payment_data.method === "credit_card" &&
                    _vm.order.order_payment_failure &&
                    !_vm.order.is_reviewed
                  ? [
                      _c("div", { staticClass: "mt-3" }, [
                        _vm._m(1),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "message.alert.payment_error_cannot_charge",
                                {
                                  msg:
                                    _vm.order.order_payment_failure
                                      .failure_message
                                }
                              )
                            ) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-info btn-block",
                              attrs: {
                                to:
                                  "/reservation/" +
                                  _vm.order.id +
                                  "/confirm-professional-booking"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.button.change_payment_method"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.order.order_payment_failure &&
                      _vm.order.order_payment_failure.failure_code ===
                        "insufficient_fund"
                        ? _c("div", [
                            _c("div", { staticClass: "mt-4" }, [
                              _vm._m(2),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.alert.insufficient_fund_remark"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-3" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-info btn-block",
                                  on: {
                                    click: function($event) {
                                      return _vm.openConfirmCreditCardLimitDialog()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.button.confirm_credit_limit"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("confirm-bank-transfer-modal", { ref: "confirmBankTransferModal" }),
      _vm._v(" "),
      _c("confirm-credit-card-payment-modal", {
        ref: "confirmCreditCardPaymentModal",
        attrs: { order: _vm.order }
      }),
      _vm._v(" "),
      _c("my-promo-code-modal", {
        ref: "myPromoCodeModal",
        attrs: { searchParams: _vm.searchParams },
        on: { onSelected: _vm.selectPromoCode }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification -status-pending" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification -status-pending" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification -status-pending" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15d8d665", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15d8d665","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/ConfirmOrderPaymentSection.vue
// module id = 1722
// module chunks = 0